// extracted by mini-css-extract-plugin
export var columnContent = "columns-slide-module--columnContent--c6e17";
export var columnContent1 = "columns-slide-module--columnContent1--76725";
export var columnContent2 = "columns-slide-module--columnContent2--b0b60";
export var columnContent3 = "columns-slide-module--columnContent3--9b776";
export var image = "columns-slide-module--image--d493b";
export var imageColumn = "columns-slide-module--imageColumn--5da7e";
export var title = "columns-slide-module--title--61825";